import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { phraseIdFieldName } from '../../declarations/filter/filter';
import { Bem } from '../../service/Bem/Bem';
import { serializeFilterToString } from '../../service/FilterHelpers/FilterHelpers';
import { metrikaApi, MetrikaCounter } from '../../service/Metrika/metrikaApi';
import { UrlHelpers } from '../../service/UrlHelpers';
import { LinkTarget } from '../../typings/common';
import { FilterExpressionValueType, Operator } from '../../typings/filter';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';

import './ShowUnsavedBannersButton.css';
import * as keyset from './ShowUnsavedBannersButton.i18n';

const i18n = i18nFactory(keyset);

export interface ShowUnsavedBannersButtonProps {
    login: string;
    bannersIds: Array<string>;
    metrikaGoalToReach?: string;
}

export class ShowUnsavedBannersButton extends React.PureComponent<ShowUnsavedBannersButtonProps> {
    render() {
        return (
            <ButtonDecorator
                cls={Bem.cls('show-unsaved-banners-button')}
                theme={'raised'}
                view={'default'}
                size={'s'}
                onClick={this.onClick}
                text={i18n('show-banners')}
            />
        );
    }
    private onClick = () => {
        const { login, bannersIds, metrikaGoalToReach } = this.props;
        const filter = serializeFilterToString([
            {
                field: phraseIdFieldName,
                operator: Operator.EQUALS,
                value: {
                    type: FilterExpressionValueType.numberSet,
                    value: bannersIds
                }
            }
        ]);
        const link = UrlHelpers.getBannersListUrl({
            ulogin: login,
            filter: filter
        });

        if (metrikaGoalToReach) {
            metrikaApi.reachGoal(MetrikaCounter.COUNTER_34, metrikaGoalToReach);
        }

        return UrlHelpers.openUrl(link, LinkTarget.blank);
    };
}
